module.exports = __webpack_public_path__ + "img/footer_logo_BARCELONA_cn.ea009d54.svg";